class StoriesSwiper {
    constructor(swiperContainerSelector = ".swiper-container_stories", startIndex = 0, enabled = true) {
        this.swiper = new Swiper(swiperContainerSelector, {
            direction: "horizontal",
            loop: false,
            slidesPerView: "auto",
            spaceBetween: 15,
            centeredSlides: true,
            allowTouchMove: true,
            navigation: {
                nextEl: `${swiperContainerSelector} .swiper-navigation-next`,
                prevEl: `${swiperContainerSelector} .swiper-navigation-prev`,
            },

            breakpoints: {
                2456: {
                    slidesPerView: 1,
                    spaceBetween: 130,
                },
                1919: {
                    slidesPerView: 1,
                    spaceBetween: 55,
                },
                1439: {
                    slidesPerView: 1,
                    spaceBetween: 85,
                },
                1279: {
                    slidesPerView: 1,
                    spaceBetween: 105,
                },
                1023: {
                    slidesPerView: 1,
                    spaceBetween: 75,
                },
                768: {
                    slidesPerView: 1,
                    spaceBetween: 75,
                },
                767: {
                    spaceBetween: 0,
                    slidesPerView: 1,
                },
            },

            on: {
                init: (sw) => this.onInit(sw, startIndex, swiperContainerSelector),
                realIndexChange: (sw) => this.onRealIndexChange(sw),
            },
        });

        this.enabled = enabled;
    }

    onInit(sw, startIndex, swiperContainerSelector) {
        $(sw.$el).addClass("shown");

        $(`${swiperContainerSelector} .swiper-arrow-prev`).on('click', () => {
            this.slidePrev();
        })
        $(`${swiperContainerSelector} .swiper-arrow-next`).on('click', () => {
            this.slideNext();
        })

        sw.slideToLoop(startIndex, 0);

        var currentVideo =
            sw.slides[sw.activeIndex].querySelector("video");
        var currentImage =
            sw.slides[sw.activeIndex].querySelector("img");

        // add event listeners only once on init for performance
        for (var i = 0; i < sw.slides.length; i++) {
            var video = sw.slides[i].querySelector("video");
            if (video) {
                video.pause();
                video.muted = false;
                video.autoplay = false;
                video.removeAttribute("muted");
                video.removeAttribute("autoplay");

                video.addEventListener("play", function () {
                    this.currentTime = 0;
                });

                video.addEventListener('timeupdate', function () {
                    var progress = (this.currentTime / this.duration) * 100;
                    this.parentElement.closest('.stories-item').querySelector('.story-line-before').style.width = progress + '%';
                });

                // change slide on video finish
                video.addEventListener("ended", () => {
                    this.slideNext();
                });
            }
        }

        if (currentVideo) {
            this.playVideo(currentVideo);
        }
        if (currentImage) {
            this.defaultPlay(currentImage);
        }
    }

    onRealIndexChange(sw) {
        var currentVideo =
            sw.slides[sw.activeIndex].querySelector("video");
        var currentImage =
            sw.slides[sw.activeIndex].querySelector("img");

        // stop and reset all videos
        for (var i = 0; i < sw.slides.length; i++) {
            if (sw.slides[i].querySelector("video")) {
                sw.slides[i].querySelector("video").pause();
                sw.slides[i].querySelector("video").currentTime = 0;
            }
        }

        if (this.timeout) {
            clearTimeout(this.timeout);
            this.timeout = null;
        }

        if (currentVideo) {
            this.playVideo(currentVideo);
        }

        if (currentImage) {
            this.defaultPlay(currentImage, sw);
        }
    }

    pause() {
        if (this.currentVideo != undefined) this.currentVideo.pause();
        if (this.timeout) {
            clearTimeout(this.timeout);
            this.timeout = null;
        }
    }

    resume(index) {
        if (index !== undefined)
            this.swiper.slideToLoop(index, 0);
        if (this.currentVideo) this.currentVideo.play();
    }

    get currentVideo() {
        return this.swiper.slides[this.swiper.activeIndex].querySelector("video");
    }

    defaultPlay(currentImage) {
        let duration = 10000;
        $(
            currentImage.parentElement
                .closest(".stories-item")
                .querySelector(".story-line-before")
        )
            .stop(true, true)
            .animate(
                {
                    width: "0%",
                },
                0
            );
        $(
            currentImage.parentElement
                .closest(".stories-item")
                .querySelector(".story-line-before")
        )
            .stop(true, true)
            .animate(
                {
                    width: "100%",
                },
                duration
            );

        this.timeout = setTimeout(() => {
            console.log('Timeout next slide');
            this.slideNext();
        }, duration);
    }

    playVideo(video) {
        //start current video
        var playPromise = video.play();

        if (playPromise) {
            playPromise
                .then((_) => {
                    // Automatic playback started!
                    // Show playing UI.
                })
                .catch((error) => {
                    // Auto-play was prevented
                    // Show paused UI.
                    console.log("play error", error);
                    video.controls = true;
                });
        }
    }

    slidePrev() {
        if (this.swiper.isBeginning) {
            this.swiper.slideTo(this.swiper.slides.length - 1);
        } else {
            this.swiper.slidePrev();
        }
    }

    slideNext() {
        if (this.swiper.isEnd) {
            this.swiper.slideTo(0);
        } else {
            this.swiper.slideNext();
        }
    }

    get enabled() {
        return this.swiper.enabled;
    }

    set enabled(value) {
        this.swiper.enabled = value;
    }
}


export default StoriesSwiper;
